module.exports = __webpack_public_path__ + "static/img/GI@3x.e2c22c15.jpg";